import { render, staticRenderFns } from "./public-share-layout.vue?vue&type=template&id=bb62466a&scoped=true"
import script from "./public-share-layout.vue?vue&type=script&lang=js"
export * from "./public-share-layout.vue?vue&type=script&lang=js"
import style0 from "./public-share-layout.vue?vue&type=style&index=0&id=bb62466a&prod&lang=css"
import style1 from "./public-share-layout.vue?vue&type=style&index=1&id=bb62466a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62466a",
  null
  
)

export default component.exports